// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"640":"94bdabfd","703":"46218a12","869":"70b81651"}[chunkId] + ".css";
};